import { evaluateStepMessage } from './evaluateStepMessage.js';
import { validateStep } from './validateStep.js';
import { cleanObject } from '../utils/cleanObject.js';
import { cleanUpWorkflowStep } from './cleanUpWorkflowStep.js';
import { getStepChangeDiff } from './getStepChangeDiff.js';
import { findStepApp } from './findStepApp.js';

export const updateWorkflowStep = async ({ id, data = {}, userId, apps, appsMetadata, workflow, companyId, credential, encodeWebhookUrl = () => {} }) => {
  const steps = workflow?.steps;
  const step = steps?.find((n) => n?.id === id);
  const appId = data?.appId ?? step?.appId;
  const appVersion = data?.appVersion ?? step?.appVersion ?? '0';
  const app = findStepApp({ appId, appVersion }, apps);

  if (app === undefined) {
    console.log('major error we dont have app!', app, 'apps', apps, 'appid and version', appId, appVersion);
  }

  const isMessageManual = data.isMessageManual === undefined ? step?.isMessageManual : !!data.isMessageManual;
  const message = isMessageManual ? data?.message : step?.message;

  const payload = {
    ...data,
    appSlug: app?.slug,
    isMessageManual,
    message,
    meta: {
      ...data?.meta,
      branches: app?.slug === 'ifElse' ? 2 : 0
    },
    updatedBy: data.userId,
    updatedOn: new Date()
  };

  const newStep = cleanObject({ ...step, ...payload });

  if (!isMessageManual && !!app?.id) {
    // todo we can't run this if we don't have the step locally. it's an issue.
    newStep.message = await evaluateStepMessage({
      app,
      step: newStep,
      workflow,
      apps,
      appsMetadata
    });
  }

  // Compute the webhook URL.
  if (newStep?.appSlug === 'webhook') {
    if (!newStep?.arguments?.url) {
      try {
        const argKey = 'arguments';
        newStep[argKey] = {
          ...newStep[argKey],
          url: encodeWebhookUrl({ companyId, workflowId: workflow?.id, stepId: id })
        };
        if (newStep.options?.queueWebhooks === undefined) {
          newStep.options = {
            ...newStep.options,
            queueWebhooks: true
          };
        }
      } catch (e) {
        console.error('error encoding webhook url', e);
      }
    }
    const hasRespondToWebhookStep = workflow?.steps?.some((step) => step?.appSlug === 'webhookResponse');
    const isSynchronous = newStep?.options?.queueWebhooks === false;
    if (hasRespondToWebhookStep && !isSynchronous) {
      newStep.options = {
        ...newStep.options,
        queueWebhooks: false
      };
    }
  }

  // On the step itself: newStep was copied from payload above, so a flag set on
  // payload now would never be saved and is_valid would keep its old value.
  const validation = await validateStep({ workflow, app, step: newStep, credential });
  newStep.isValid = validation?.status === 'valid';
  newStep.meta = { ...newStep.meta, validation };

  // Remove invalid arguments
  const cleanStep = cleanUpWorkflowStep({ step: newStep, app, workflow });
  const changes = getStepChangeDiff({ userId, updatedStep: cleanStep, originalStep: step });

  return {
    ...cleanStep,
    meta: { ...cleanStep?.meta, changes }
  };
};
